function SkeletonLine({ className = "" }) {
    return <span className={`productSkeleton__line ${className}`.trim()} aria-hidden="true" />
}

export function ProductGridSkeleton({ cards = 6 }) {
    return (
        <section className="product__grid" aria-label="Загрузка списка продуктов">
            {Array.from({ length: cards }).map((_, index) => (
                <article className="product__card product__card_skeleton" key={index}>
                    <div className="product__cardMedia productSkeleton__block" />
                    <div className="product__cardBody">
                        <SkeletonLine className="productSkeleton__line_title" />
                        <SkeletonLine className="productSkeleton__line_body" />
                        <SkeletonLine className="productSkeleton__line_body productSkeleton__line_bodyShort" />
                        <SkeletonLine className="productSkeleton__line_price" />
                    </div>
                </article>
            ))}
        </section>
    )
}

export function CalculatorSkeleton() {
    return (
        <section className="calculator" aria-label="Загрузка калькулятора">
            <div className="calculator__config productSkeleton__panel">
                <div className="calculator__group">
                    <SkeletonLine className="productSkeleton__line_sectionTitle" />
                    <div className="calculator__products">
                        {Array.from({ length: 4 }).map((_, index) => (
                            <div className="calculator__check productSkeleton__check" key={index}>
                                <span className="productSkeleton__tick" aria-hidden="true" />
                                <span className="productSkeleton__checkContent">
                                    <SkeletonLine className="productSkeleton__line_label" />
                                    <SkeletonLine className="productSkeleton__line_hint" />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {Array.from({ length: 2 }).map((_, index) => (
                    <section className="calculator__productConfig productSkeleton__section" key={index}>
                        <SkeletonLine className="productSkeleton__line_subtitle" />
                        <div className="productSkeleton__numberRow">
                            <SkeletonLine className="productSkeleton__line_body" />
                            <span className="productSkeleton__input" aria-hidden="true" />
                        </div>
                        <div className="calculator__options">
                            {Array.from({ length: 3 }).map((__, itemIndex) => (
                                <div className="calculator__option productSkeleton__option" key={itemIndex}>
                                    <SkeletonLine className="productSkeleton__line_label" />
                                    <SkeletonLine className="productSkeleton__line_hint" />
                                </div>
                            ))}
                        </div>
                    </section>
                ))}

                <div className="calculator__group">
                    <SkeletonLine className="productSkeleton__line_subtitle" />
                    <div className="calculator__options">
                        {Array.from({ length: 3 }).map((_, index) => (
                            <div className="calculator__option productSkeleton__option" key={index}>
                                <SkeletonLine className="productSkeleton__line_label" />
                                <SkeletonLine className="productSkeleton__line_hint" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <aside className="calculator__summary productSkeleton__panel">
                <SkeletonLine className="productSkeleton__line_sectionTitle" />
                <div className="productSkeleton__summaryList">
                    {Array.from({ length: 5 }).map((_, index) => (
                        <div className="productSkeleton__summaryRow" key={index}>
                            <SkeletonLine className="productSkeleton__line_hint" />
                            <SkeletonLine className="productSkeleton__line_hint productSkeleton__line_hintShort" />
                        </div>
                    ))}
                </div>
                <SkeletonLine className="productSkeleton__line_total" />
                <span className="productSkeleton__button" aria-hidden="true" />
            </aside>
        </section>
    )
}

export function ProductDetailSkeleton() {
    return (
        <main className="product productDetail" aria-label="Загрузка страницы продукта">
            <section className="productDetail__hero productSkeleton__hero">
                <div className="productDetail__heroMeta">
                    <SkeletonLine className="productSkeleton__line_tag" />
                    <SkeletonLine className="productSkeleton__line_tag productSkeleton__line_tagWide" />
                </div>

                <div className="productDetail__titleLine productSkeleton__titleLine">
                    <SkeletonLine className="productSkeleton__line_heading" />
                    <span className="productSkeleton__icon" aria-hidden="true" />
                </div>

                <div className="productDetail__heroCopy">
                    <SkeletonLine className="productSkeleton__line_body" />
                    <SkeletonLine className="productSkeleton__line_body" />
                    <SkeletonLine className="productSkeleton__line_body productSkeleton__line_bodyShort" />
                    <div className="productDetail__heroActions">
                        <span className="productSkeleton__button" aria-hidden="true" />
                        <span className="productSkeleton__button productSkeleton__button_secondary" aria-hidden="true" />
                    </div>
                </div>

                <aside className="productDetail__heroPanel">
                    <div className="productDetail__priceCard productSkeleton__priceCard">
                        <SkeletonLine className="productSkeleton__line_hint productSkeleton__line_hintShort" />
                        <SkeletonLine className="productSkeleton__line_total" />
                        <SkeletonLine className="productSkeleton__line_hint" />
                    </div>
                </aside>
            </section>

            <section className="productDetail__showcase">
                <div className="productDetail__sectionHeader">
                    <SkeletonLine className="productSkeleton__line_tag" />
                    <SkeletonLine className="productSkeleton__line_sectionTitle" />
                    <SkeletonLine className="productSkeleton__line_body" />
                </div>
                <div className="productSkeleton__browser">
                    <div className="productSkeleton__browserBar" />
                    <div className="productSkeleton__browserBody" />
                </div>
            </section>

            <section className="productDetail__valueSection">
                <div className="productDetail__sectionHeader">
                    <SkeletonLine className="productSkeleton__line_tag" />
                    <SkeletonLine className="productSkeleton__line_sectionTitle" />
                </div>
                <div className="productDetail__featureGrid">
                    {Array.from({ length: 3 }).map((_, index) => (
                        <article className="productDetail__featureCard productSkeleton__featureCard" key={index}>
                            <span className="productSkeleton__featureBadge" aria-hidden="true" />
                            <SkeletonLine className="productSkeleton__line_label" />
                            <SkeletonLine className="productSkeleton__line_hint" />
                            <SkeletonLine className="productSkeleton__line_hint productSkeleton__line_bodyShort" />
                        </article>
                    ))}
                </div>
            </section>

            <section className="productDetail__content productSkeleton__content">
                <SkeletonLine className="productSkeleton__line_tag" />
                <SkeletonLine className="productSkeleton__line_sectionTitle" />
                <SkeletonLine className="productSkeleton__line_body" />
                <SkeletonLine className="productSkeleton__line_body" />
                <SkeletonLine className="productSkeleton__line_body productSkeleton__line_bodyShort" />
            </section>

            <section className="productDetail__finalCta productSkeleton__finalCta">
                <div className="productSkeleton__ctaCopy">
                    <SkeletonLine className="productSkeleton__line_tag" />
                    <SkeletonLine className="productSkeleton__line_sectionTitle" />
                    <SkeletonLine className="productSkeleton__line_body" />
                </div>
                <div className="productDetail__finalActions">
                    <span className="productSkeleton__button" aria-hidden="true" />
                    <span className="productSkeleton__button productSkeleton__button_secondary" aria-hidden="true" />
                </div>
            </section>
        </main>
    )
}
